import axios, { AxiosInstance } from 'axios';

/**
 * Abstract base class for API services providing common functionality
 */
abstract class BaseApiService {
    protected httpClient: AxiosInstance;
    protected baseUrl: string;

    constructor(baseUrl: string, httpClient: AxiosInstance = axios) {
        this.httpClient = httpClient;
        this.baseUrl = baseUrl;
    }

    /**
     * Common error handling for API requests
     */
    protected handleError(error: any, context: string): never {
        console.error(`❌ [${context}] API request failed:`, {
            error: error.message,
            status: error.response?.status,
            data: error.response?.data
        });
        throw error;
    }

    /**
     * Common logging for API requests
     */
    protected logRequest(method: string, endpoint: string, data?: any): void {
        console.log(`🔍 [DEBUG] ${method} request:`, {
            url: `${this.baseUrl}${endpoint}`,
            data: data ? '[DATA_PRESENT]' : undefined
        });
    }

    /**
     * Log API response
     */
    protected logResponse(method: string, status: number, data?: any): void {
        console.log(`🔍 [DEBUG] ${method} response status:`, status);
        console.log(`🔍 [DEBUG] ${method} response data:`, data);
    }

    // Abstract methods that concrete classes must implement
    abstract getRequest(endpoint: string, params?: any): Promise<any>;
    abstract postRequest(endpoint: string, data?: any): Promise<any>;
    abstract putRequest(endpoint: string, data?: any): Promise<any>;
}

export default BaseApiService;
